module.exports = __webpack_public_path__ + "static/media/assortment_truck.1e331388.svg";